export default "__VITE_ASSET__pAi_DSHd__"